import { render, staticRenderFns } from "./InboxDetailReply.vue?vue&type=template&id=9c64c434&scoped=true&"
import script from "./InboxDetailReply.vue?vue&type=script&lang=js&"
export * from "./InboxDetailReply.vue?vue&type=script&lang=js&"
import style0 from "./InboxDetailReply.vue?vue&type=style&index=0&id=9c64c434&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c64c434",
  null
  
)

export default component.exports